module.exports = __webpack_public_path__ + "media/assets/avia/sidebar/air-2da92b5552ea2a50fc7ded3b8d224f3c.png";